'use client';

import { cn, getColorwayWithTransparency, getYMargins } from '@/utils/styles';
import CardsVerticalScrollItemMobile from './CardsVerticalScrollMobileItem';
import { CardsVerticalScrollProps } from './types';
import { Colorways, Margins } from '@/types/constants';
import { useStickyHeaderOffset } from './useStickyHeaderOffset';

const CardsVerticalScroll = ({
  sectionName,
  margins,
  transparentBackground,
  offsetMobileScrollTop,
  cards,
}: CardsVerticalScrollProps) => {
  const cardItems = cards?.items ?? [];
  const stickyTopOffset = useStickyHeaderOffset();

  return (
    <div
      id={sectionName}
      data-testid="mobile-version"
      className={cn(
        'relative md:hidden sm:block sm:overflow-visible w-full',
        getYMargins(margins ?? Margins.Centered),
        getColorwayWithTransparency(Colorways.DarkGreenGradientLeftToRight, transparentBackground),
      )}>
      {cardItems.map((card, index) => (
        <CardsVerticalScrollItemMobile
          {...card}
          key={card.sys.id}
          index={index}
          stickyTopOffset={stickyTopOffset}
          offsetMobileScrollTop={offsetMobileScrollTop}
        />
      ))}
    </div>
  );
};

export default CardsVerticalScroll;
